<template>
  <div class="wrap">
    <div class="box EC_width">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/user/userorgCourse' }">自训课程</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="midbox EC_width display_flex">
        <div class="mleft">
          <div v-if="info != null">
            <div id="mp4" class="box" v-show="player != null"></div>
            <div class="fengmian display_center" v-show="player == null"
              :style="'background-image: url(' + info.coverpicture + ');'">
              <img src="../../assets/img/bofang.png" @click="toPlay" alt="" />
            </div>
          </div>
        </div>
        <div class="mright">
          <div class="mrmid">
            <div class="mrbox" :style="index == 0 ? 'border-top:0' : ''" v-for="(item, index) in courseList"
              @click="toCourse(item)" :key="index">
              <div class="mrbt display_between_nocenter">
                <div class="mrbq" :style="item.id == cid ? 'background: #08A4A5;color:#fff' : ''">
                  <span>{{ item.resType == 2 ? '视频' : (item.resType == 3 ? '音频' : '电子书') }}</span>
                </div>
                <div class="mrtitle" :style="item.id == cid ? 'color: #08A4A5;' : ''">
                  <span>{{ item.title }}</span>
                </div>
                <img src="../../assets/img/boFangIcon.png" v-show="item.id == cid && isBofang == false" alt="">
                <img src="../../assets/img/bofang.gif" v-show="item.id == cid && isBofang == true" alt="">
              </div>
              <div class="mrbm display_column">
                <span v-show="orgName != ''">机构：{{ orgName }}</span>
                <span v-show="item.resType != 4">时长：
                  <span
                    style="font-weight: 800;">{{ item.standingtime == 0 ? '0:00' : item.standingtime.toFixed(2).toString().replace('.',
                        ':')
                    }}</span>
                  <span>/{{ item.res_duration.toFixed(2).toString().replace('.', ':') }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Player from 'xgplayer';
export default {
  data() {
    return {
      courseList: [],
      cid: 0,
      uid: 0,
      orgid: 0,
      title: '课程详情',
      orgName: '',
      isBofang: false,
      player: null,
      info: null,
      stime: 0
    };
  },
  created() {
    if (localStorage.getItem('ResData')) {
      this.uid = Number(JSON.parse(localStorage.getItem('ResData')).id);
    }
    this.cid = Number(this.$route.query.cid)
    this.orgid = Number(this.$route.query.orgid)
    this.getOrgName()
    this.GetCourseList()
    this.getMp4()
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.query.cid && this.$route.query.cid != this.cid) {
          this.cid = Number(this.$route.query.cid)
          this.getMp4()
          this.GetCourseList()
        }
      },
      deep: true
    }
  },
  mounted() {
    window.addEventListener('beforeunload', () => {
      if (this.player) this.toRecordMp4();
    });
    window.addEventListener('onunload', () => {
      if (this.player) this.toRecordMp4();
    });
    window.addEventListener('unload', () => {
      if (this.player) this.toRecordMp4();
    });
  },
  beforeDestroy() {
    if (this.player) this.toRecordMp4();
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.toRecordMp4);
    window.removeEventListener('unload', this.toRecordMp4);
    window.removeEventListener('onunload', this.toRecordMp4);
  },
  methods: {
    GetCourseList() {
      this.httphelper.get('/api/EnterpriseApi/GetUserIntCourseList', {
        orgid: this.orgid,
        userId: this.uid
      })
        .then(res => {
          if (res.code == 200) {
            this.courseList = res.data
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].id == this.cid) {
                this.title = res.data[i].title
              }
            }
            if (this.title == '课程详情') {
              this.$confirm('该课程已下架', '提示', {
                confirmButtonText: '返回首页',
                showCancelButton: false,
                showClose: false
              }).then(() => {
                this.$router.push('/home');
              });
            }
          }
        });
    },
    getOrgName() {
      this.httphelper.get('/api/CGPEnterPriseApi/GetGpOrganInfoById', {
        id: this.orgid
      })
        .then(res => {
          if (res.code == 200) {
            this.orgName = res.data.org_name
          }
        });
    },
    getMp4() {
      this.stime = 0
      if (this.player) {
        this.player.destroy();
        this.player = null;
        this.httphelper
          .post('/api/EnterpriseApi/GetIntCourseDeta', {
            courseId: this.cid,
            userId: this.uid,
          })
          .then(res => {
            if (res.data.code == 200) {
              this.info = res.data.data
              this.toPlay()
            }
          });
      } else {
        this.httphelper
          .post('/api/EnterpriseApi/GetIntCourseDeta', {
            courseId: this.cid,
            userId: this.uid,
          })
          .then(res => {
            if (res.data.code == 200) {
              this.info = res.data.data
            }
          });
      }
    },
    toPlay() {
      let minute = Number(this.info.standingtime.toFixed(2).split('.')[0]) * 60;
      let second = Number(this.info.standingtime.toFixed(2).split('.')[1]);
      let starTime = minute + second;
      let ignores = this.info.isFastForward ? [] : ['progress'];
      this.player = new Player({
        id: 'mp4',
        url: this.info.resUrl,
        autoplay: true,
        playsinline: true,
        width: '100%',
        height: '100%',
        lastPlayTime: starTime,
        ignores: ignores,
        rotateFullscreen: false,
        'x5-video-player-type': 'h5',
        'x5-video-orientation': 'portraint',
        playbackRate: [0.5, 1, 1.5, 2, 3],
      });
      this.player.on('ended', () => {
        this.toRecordMp4();
      });
      this.player.on('pause', () => {
        this.isBofang = false
      });
      this.player.on('playing', () => {
        this.isBofang = true
      });
      this.player.on('timeupdate', e => {
        var soupttime = parseInt(e.currentTime / 60) + Math.ceil(e.currentTime % 60) / 100;
        if (this.stime != soupttime) {
          this.stime = soupttime;
        }
      });
    },
    toRecordMp4() {
      if (this.stime == 0 || this.uid == 0) return;
      var img = document.createElement("img");
      img.src = this.httphelper
        .get('/api/EnterpriseApi/UpdIntCourseRecord', {
          courseid: this.cid,
          userId: this.uid,
          standingtime: this.stime,
        });
      document.body.appendChild(img);
      this.stime = 0
      this.GetCourseList()
      img.style.display = 'none'
    },
    toCourse(item) {
      if (item.id == this.cid) return
      if (this.player) this.toRecordMp4();
      this.$router.push({
        path: '/course',
        query: {
          cid: item.id,
          orgid: this.orgid
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.wrap {
  min-height: 600px;
}

.breadcrumb {
  height: 50px;
  line-height: 50px;
  border-top: 1px solid #eee;
}

.midbox {
  height: 500px;
  margin-bottom: 40px;
  background: #15161b;

  .mleft {
    width: 890px;
    height: 100%;

    .box {
      width: 890px !important;
      height: 500px !important;

      ::v-deep .xgplayer-replay {
        z-index: 10;
      }
    }

    .fengmian {
      width: 890px;
      height: 500px;
      background-size: 100% 100%;

      img {
        cursor: pointer;
      }

      image-rendering: -moz-crisp-edges;
      image-rendering: -o-crisp-edges;
      image-rendering: -webkit-optimize-contrast;
      image-rendering: crisp-edges;
      -ms-interpolation-mode: nearest-neighbor;
    }
  }

  .mright {
    width: 350px;
    height: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    background: #15161b;
    overflow-y: scroll;
    scrollbar-color: transparent transparent;
    scrollbar-arrow-color: #f0f2f5;
    scrollbar-base-color: #f0f2f5;
    scrollbar-track-color: #f0f2f5;
    scrollbar-shadow-color: #f0f2f5;

    .mrmid {
      margin: 0 20px;

      .mrbox {
        padding: 20px 0;
        border-top: 1px solid #2a2a2a;
        cursor: pointer;

        .mrbt {
          .mrbq {
            width: 50px;
            height: 18px;
            background: #c7c7c7;
            border-radius: 1px;
            text-align: center;
            font-size: 13px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            line-height: 18px;
            padding: 1px 0;
          }

          .mrtitle {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #c7c7c7;
            line-height: 22px;
            flex: 1;
            margin: -2px 15px 0 10px;
          }

          img {
            width: 15px;
            height: 16px;
            margin-top: 2px;
          }
        }

        .mrbm {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #777777;
          line-height: 22px;
          margin-top: 6px;
        }
      }
    }
  }

  .mright::-webkit-scrollbar {
    width: 6px;
    height: 4px;
  }

  .mright::-webkit-scrollbar-thumb {
    background-color: #6d6d6d;
    border-radius: 6px;
  }

  .mright::-webkit-scrollbar-track {
    background-color: #15161b;
    border-radius: 6px;
  }
}
</style>
